import { flushSync } from "react-dom";
import { Row, Typography } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { API_URL, monthNames } from "../../constants";

const MonthBlockLine = () => {
  const [blocked, setBlocked] = useState(null);
  const [date, setDate] = useState({
    month: null,
    year: null,
  });

  useEffect(() => {
    const getBlockStatus = async () => {
      try {
        const res = await axios.get(
          `${API_URL}/gestionar/blockageStatus/month`
        );
        const data = res.data;
        const isBlocked = data.blocked === true || data.blocked === "true";

        // 👇 Force React to apply immediately (prevents blink)
        flushSync(() => {
          setBlocked(isBlocked);
          setDate({ month: data.month, year: data.year });
        });
      } catch (error) {
        flushSync(() => setBlocked(false));
        console.error(error);
      }
    };

    getBlockStatus();
  }, []);

  if (!blocked) return null;

  return (
    <Row
      align="middle"
      justify="center"
      style={{
        width: "100vw",
        height: 22,
        background: "red",
      }}
    >
      <Typography.Text
        style={{ color: "white", fontSize: 16, lineHeight: "16px" }}
      >
        Toate modificările vor fi efectuate pentru luna trecută (
        {monthNames[(date.month ?? 1) - 1]} {date.year})
      </Typography.Text>
    </Row>
  );
};

export default MonthBlockLine;
